/**
 * BillingWalletApi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ClientResourceWallet } from '../model/clientResourceWallet';
import { ClientResourceWalletMapDto } from '../model/clientResourceWalletMapDto';
import { ProblemDetails } from '../model/problemDetails';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ClientResourceWalletService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param clientResourceId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiClientResourceWalletClientResourceIdGet(clientResourceId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ClientResourceWallet>>;
    public apiClientResourceWalletClientResourceIdGet(clientResourceId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ClientResourceWallet>>>;
    public apiClientResourceWalletClientResourceIdGet(clientResourceId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ClientResourceWallet>>>;
    public apiClientResourceWalletClientResourceIdGet(clientResourceId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (clientResourceId === null || clientResourceId === undefined) {
            throw new Error('Required parameter clientResourceId was null or undefined when calling apiClientResourceWalletClientResourceIdGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ClientResourceWallet>>('get',`${this.basePath}/api/ClientResourceWallet/${encodeURIComponent(String(clientResourceId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param walletId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiClientResourceWalletDelete(walletId?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiClientResourceWalletDelete(walletId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiClientResourceWalletDelete(walletId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiClientResourceWalletDelete(walletId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (walletId !== undefined && walletId !== null) {
            queryParameters = queryParameters.set('walletId', <any>walletId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/api/ClientResourceWallet`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param walletId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiClientResourceWalletGet(walletId?: string, observe?: 'body', reportProgress?: boolean): Observable<ClientResourceWallet>;
    public apiClientResourceWalletGet(walletId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ClientResourceWallet>>;
    public apiClientResourceWalletGet(walletId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ClientResourceWallet>>;
    public apiClientResourceWalletGet(walletId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (walletId !== undefined && walletId !== null) {
            queryParameters = queryParameters.set('walletId', <any>walletId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ClientResourceWallet>('get',`${this.basePath}/api/ClientResourceWallet`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param walletId 
     * @param clientResourceId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiClientResourceWalletGetByClientResourceIdAndWalletIdGet(walletId?: string, clientResourceId?: string, observe?: 'body', reportProgress?: boolean): Observable<ClientResourceWallet>;
    public apiClientResourceWalletGetByClientResourceIdAndWalletIdGet(walletId?: string, clientResourceId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ClientResourceWallet>>;
    public apiClientResourceWalletGetByClientResourceIdAndWalletIdGet(walletId?: string, clientResourceId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ClientResourceWallet>>;
    public apiClientResourceWalletGetByClientResourceIdAndWalletIdGet(walletId?: string, clientResourceId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (walletId !== undefined && walletId !== null) {
            queryParameters = queryParameters.set('walletId', <any>walletId);
        }
        if (clientResourceId !== undefined && clientResourceId !== null) {
            queryParameters = queryParameters.set('clientResourceId', <any>clientResourceId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ClientResourceWallet>('get',`${this.basePath}/api/ClientResourceWallet/GetByClientResourceIdAndWalletId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiClientResourceWalletPost(body?: ClientResourceWalletMapDto, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public apiClientResourceWalletPost(body?: ClientResourceWalletMapDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public apiClientResourceWalletPost(body?: ClientResourceWalletMapDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public apiClientResourceWalletPost(body?: ClientResourceWalletMapDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<string>('post',`${this.basePath}/api/ClientResourceWallet`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
